// extracted by mini-css-extract-plugin
module.exports = {"footer":"style__footer__2SNqh","wrapper":"style__wrapper__K1GSD","signature":"style__signature__GyRnP","marginBottom":"style__marginBottom__qAG2H"};